import { useOverflowingElement } from '@agilelab/plugin-wb-platform';
import { Entity } from '@backstage/catalog-model';
import { Box } from '@material-ui/core';
import { FC, useRef } from 'react';
import { ComponentIcon } from '../ComponentIcon';

interface Props {
  entities: Entity[];
}

export const BlueprintCardComponents: FC<Props> = ({ entities }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const overflows = useOverflowingElement(ref);

  return (
    <Box display="flex" alignItems="flex-end" style={{ gap: '8px' }}>
      <div
        ref={ref}
        style={{
          display: 'flex',
          gap: '8px',
          width: '90%',
          overflow: 'hidden',
        }}
      >
        {entities.map((template, i) => (
          <ComponentIcon key={i} entity={template} />
        ))}
      </div>

      {overflows && '...'}
    </Box>
  );
};
